export default {
  'pages.index.title': 'Liulian AI - 精准视觉优化版',
  'pages.index.brand': 'Liulian AI',
  'pages.index.nav.customer': '客服',
  'pages.index.nav.developer': '开发者',
  'pages.index.nav.register': '注册',
  'pages.index.nav.login': '登录',
  'pages.index.nav.workbench': '工作台',
  'pages.index.badge': '✦ NEXT-GEN AI PLATFORM',
  'pages.index.hero.titleLine1': '让 AI 为你',
  'pages.index.hero.typewriter.0': '释放灵感',
  'pages.index.hero.typewriter.1': '生成图片',
  'pages.index.hero.typewriter.2': '创作视频',
  'pages.index.hero.typewriter.3': '一键漫剧',
  'pages.index.hero.typewriter.4': '智能对话',
  'pages.index.hero.subtitle':
    '聚合全球顶尖大模型，从灵感到现实仅需秒级响应<br>一个平台，连接智能未来的所有可能',
  'pages.index.hero.cta.primary': '开始使用',
  'pages.index.hero.cta.business': '商务合作',
  'pages.index.stats.models': 'Models',
  'pages.index.stats.creators': 'Creators',
  'pages.index.stats.idea': 'Idea',
  'pages.index.agents.eyebrow': 'AI AGENTS',
  'pages.index.agents.title': '不只是工具，是你的创作搭档',
  'pages.index.agents.subtitle':
    '从文本到视频，从灵感到成品 —— AI 智能体为你全流程搞定，效率提升 10 倍。',
  'pages.index.agent.video.title': '一键生成视频',
  'pages.index.agent.video.desc':
    '输入文案或参考画面，AI 自动切分镜头、生成角色、配音、合成视频。全流程一键完成。',
  'pages.index.agent.longVideo.title': '智能长视频创作',
  'pages.index.agent.longVideo.desc':
    '参考画面 + 文字描述，精准控制画面内容与时长，生成连贯的专业级长视频。',
  'pages.index.agent.style.title': '风格一键切换',
  'pages.index.agent.style.desc':
    '赛博朋克、水墨国风、3D 动画、写实电影……海量风格随心切换，创作不设限。',
  'pages.index.agent.voice.title': '画面配音自动匹配',
  'pages.index.agent.voice.desc':
    '智能语音合成 + 画面节奏匹配，解说版、剧情版自由选择，让内容更有灵魂。',
  'pages.index.agent.cta': '立即体验 →',
  'pages.index.platform.eyebrow': 'PLATFORM',
  'pages.index.platform.title': '四大核心能力，一个平台',
  'pages.index.platform.chat.title': '智能对话',
  'pages.index.platform.chat.desc':
    'GPT-4o / Claude / Gemini / DeepSeek，多模型自由切换，精准回答每一个问题。',
  'pages.index.platform.image.title': '图像创作',
  'pages.index.platform.image.desc':
    'Midjourney / FLUX / 即梦 / DALL·E，输入文字即刻出图，写实、插画、3D 任选。',
  'pages.index.platform.video.title': '视频生成',
  'pages.index.platform.video.desc':
    'Sora 2 / 可灵 / Luma / Veo / Runway，文字或图片一键生成电影级视频。',
  'pages.index.platform.tts.title': '语音合成',
  'pages.index.platform.tts.desc':
    '多语言、多音色智能配音，从旁白到对白，让你的内容拥有专业级声音。',
  'pages.index.footer.copyright':
    '© 2026 榴莲AI',
  'pages.index.product.gpt4o.desc': '逻辑理解天花板',
  'pages.index.product.claude.desc': '人性化文本创作',
  'pages.index.product.midjourney.desc': '艺术级影像引擎',
  'pages.index.product.sora.desc': '视频生成奇迹',
  'pages.index.product.deepseek.desc': '最强推理模型',
  'pages.index.product.flux.desc': '细节掌控大师',
};
